module.exports = __webpack_public_path__ + "img/loupe.b2c099ef.svg";